import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ContentChildren,
    HostBinding,
    Input,
    OnInit,
    QueryList
} from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrUndefined } from 'util';

@Component({
    selector: 'cmn-menu-item',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.scss'],
    animations: [
        trigger('collapse', [
            state('true', style({
                height: 0
            })),
            state('false', style({
                height: '*'
            })),
            transition('* <=> *', animate('.2s ease-in-out'))
        ]),
        trigger('inOut', [
            state('true', style({
                left: 0
            })),
            state('false', style({
                left: '-4px'
            })),
            transition('true => false', animate('320ms ease-in-out')),
            transition('false => true', animate('320ms ease-in-out'))
        ])
    ]
})
export class MenuItemComponent implements OnInit, AfterViewInit {

    @ContentChildren(MenuItemComponent) childrenQuery: QueryList<MenuItemComponent>;
    @Input() link: string = null;
    @Input() name: string = null;
    @Input() icon: string = null;
    @Input() exactRoute: boolean = false;
    @Input() activePattern: string = '';

    public children: Array<MenuItemComponent> = [];
    public child: boolean = false;
    public level: number = 0;
    public hasActiveChildren: boolean = false;
    public active: boolean = false;
    private _collapsible: boolean = true;

    @HostBinding('class.parent-element') parent: boolean = true;
    @HostBinding('class.empty') empty: boolean = !this.parent;
    @HostBinding('class.collapsed') collapsed: boolean = false;

    set initialState(initialState: 'collapsed' | 'expanded') {
        Promise.resolve(null).then(() => {
            this.collapsed = initialState === 'collapsed';
        });
    }

    set collapsible(collapsible: boolean) {
        Promise.resolve(null).then(() => this._collapsible = collapsible);
        if (collapsible === false) {
            Promise.resolve(null).then(() => {
                this.initialState = 'expanded';
            });
        }
    }

    get collapsible() {
        return this._collapsible;
    }

    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private router: Router,
        private activeRoute: ActivatedRoute
    ) {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        this.children = this.childrenQuery.toArray().filter(item => item !== this);
        if (this.children.length) {
            this.setParent();
            this.children.reverse().map(item => {
                this.levelUpForAllChildren(item);
            });
            this.changeDetectorRef.detectChanges();
        } else {
            Promise.resolve(null).then(() => this.parent = false);
            Promise.resolve(null).then(() => this.empty = true);
        }
    }

    public levelUp(parent: MenuItemComponent) {
        this.level = parent.level + 1;
        this.changeDetectorRef.detectChanges();
    }

    public setParent() {
        this.parent = true;
        this.changeDetectorRef.detectChanges();
    }

    public levelUpForAllChildren(item: MenuItemComponent) {
        const children: Array<MenuItemComponent> = item.children;
        item.levelUp(item);
        if (children.length) {
            item.setParent();
            children.map(menuItem => {
                menuItem.levelUp(menuItem);
            });
        }
    }

    public toggleCollapse() {
        if (!this.collapsible) {
            return;
        }
        if (this.parent) {
            if (!this.collapsed) {
                this.checkIfHasActiveChild();
            }
            this.collapsed = !this.collapsed;
        }
    }

    private checkIfHasActiveChild() {
        this.changeDetectorRef.detectChanges();
        this.hasActiveChildren = false;
        this.children.forEach((child: MenuItemComponent) => {
            if (child.active === true) {
                this.hasActiveChildren = true;
                this.changeDetectorRef.detectChanges();
            }
        });
    }

    public isActive() {
        let active: boolean = false;
        if (this.parent) {
            for (let i = 0; i < this.children.length; i++) {
                const child: MenuItemComponent = this.children[i];
                if (!isNullOrUndefined(child.link)) {
                    active = this.router.isActive(child.link, true);

                    if (child.activePattern) {
                        const regexp = new RegExp(child.activePattern);
                        active = regexp.test(this.router.url);
                    }

                    if (active) {
                        break;
                    }
                }
            }
        } else {
            active = this.router.isActive(this.link, true);
            if (this.activePattern) {
                const regexp = new RegExp(this.activePattern);
                active = regexp.test(this.router.url);
            }
        }
        return active;
    }
}
